import React, { ChangeEvent, FocusEvent, Fragment } from 'react';

import { Dropdown, Field, Spacer, TextInput } from '@zapier/design-system';

import { FIELD_VERTICAL_SPACING } from './constants';

import type { CreateActionSchema } from 'app/developer-v3/types';

type Props = {
  creates: Record<string, CreateActionSchema>;
  errorSearchOrCreateCreateKey?: string;
  errorSearchOrCreateLabel?: string;
  isDisabled: boolean;
  onBlurSearchOrCreateCreateKey: (event: FocusEvent<HTMLElement>) => void;
  onBlurSearchOrCreateLabel: (event: FocusEvent<HTMLElement>) => void;
  onChangeCreateKey: (createKeyNext: string) => void;
  onChangeSearchOrCreateLabel: (searchOrCreateLabelNext: string) => void;
  searchOrCreateCreateKey?: string;
  searchOrCreateLabel?: string;
};

function SearchOrCreate({
  creates,
  errorSearchOrCreateCreateKey,
  errorSearchOrCreateLabel,
  isDisabled,
  onBlurSearchOrCreateCreateKey,
  onBlurSearchOrCreateLabel,
  onChangeCreateKey,
  onChangeSearchOrCreateLabel,
  searchOrCreateCreateKey,
  searchOrCreateLabel,
}: Props) {
  return (
    <Fragment>
      <Field
        error={errorSearchOrCreateCreateKey}
        helpTextLineClamp={2}
        isDisabled={isDisabled}
        isRequired={true}
        label="Create Action"
        renderHelpText={() => 'Choose an Action that will create this object.'}
        renderInput={inputProps => (
          <Dropdown
            {...inputProps}
            items={Object.values(creates).map(create => ({
              label: create.display.label,
              value: create.key,
            }))}
            name="searchOrCreateCreateKey"
            onBlur={onBlurSearchOrCreateCreateKey}
            onChange={item => onChangeCreateKey(item.value)}
            placeholder="Choose an Action…"
            selectedItem={
              searchOrCreateCreateKey
                ? {
                    label: creates?.[searchOrCreateCreateKey]?.display?.label,
                    value: searchOrCreateCreateKey,
                  }
                : undefined
            }
          />
        )}
      />
      {searchOrCreateCreateKey && (
        <Fragment>
          <Spacer height={FIELD_VERTICAL_SPACING} />
          <Field
            error={errorSearchOrCreateLabel}
            helpTextLineClamp={2}
            isDisabled={isDisabled}
            isRequired={true}
            label="Find or Create Label"
            renderHelpText={() =>
              'Usually something like "Find or Create Socks"'
            }
            renderInput={inputProps => (
              <TextInput
                {...inputProps}
                name="searchOrCreateCreateLabel"
                onBlur={onBlurSearchOrCreateLabel}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  onChangeSearchOrCreateLabel(event.target.value);
                }}
                value={searchOrCreateLabel}
              />
            )}
          />
        </Fragment>
      )}
    </Fragment>
  );
}

export default SearchOrCreate;
